import axios from 'axios'
import bofhDefaultHeaders from 'services/bofhDefaultHeaders'
import {
  OfferCheckHTTPResponseType,
  OfferCheckRequestParamsType
} from 'types/OfferCheck'
import setHttpRequestId from 'utils/setHttpRequestId'
import setProfileKey from 'utils/setProfileKey'
import setRezServerFraudProtectionHeader from 'utils/setRezServerFraudProtectionHeader'

const axiosConfig = {
  headers: bofhDefaultHeaders
}

const axiosInstance = axios.create(axiosConfig)

const getOfferCheckFactory = httpService => async (
  requestParams: OfferCheckRequestParamsType,
  experimentApiKey,
  httpRequestId
): Promise<OfferCheckHTTPResponseType> => {
  const {url} = requestParams
  setHttpRequestId(httpService, httpRequestId)
  setProfileKey(httpService, experimentApiKey)
  setRezServerFraudProtectionHeader(httpService)
  return httpService.get(url)
}

const offerCheckService = getOfferCheckFactory(axiosInstance)
export {offerCheckService}
